import React, { FC } from "react";
import styled from "styled-components";
import { colors, colorNames } from "../../styles/variables";

const StyledSvg = styled.svg`
  fill: ${({ fill, theme }) => fill || theme.color.primary || colors["gray"]};
`;

interface SubscriptionTabSvgProps extends React.SVGProps<SVGSVGElement> {
  color?: colorNames;
}

export const SubscriptionTabSvg: FC<SubscriptionTabSvgProps> = ({
  color,
  className,
}) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 20"
      fill={color && colors[color]}
      className={className}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M0,0H32a0,0,0,0,1,0,0V0A20,20,0,0,1,12,20H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
          />
        </g>
      </g>
    </StyledSvg>
  );
};
